/* eslint-disable no-prototype-builtins */
function compareValues(key, order = 'asc') {
  return function innerSort(a, b) {
    if (a[key]===null) {
      return 0;
    }
    const varA = (typeof a[key] === 'string')
      ? a[key].toUpperCase() : a[key];
    const varB = (typeof b[key] === 'string')
      ? b[key].toUpperCase() : b[key];

    let comparison = 0;
    if(varA === null && varB === null) {
      return -1;
    } else if(varA === null || varB === null) {
      return -1;
    } else if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return (
      (order === 'desc') ? (comparison * -1) : comparison
    );
  };
}

// ex: [{id: 1, date:'Mar 12 2012 10:00:00 AM'}, {id: 2, date:'Mar 8 2012 08:00:00 AM'}];
export const compareDate = (a, b) => {
  const c = new Date(a);
  const d = new Date(b);
  return d-c;
};

export const compareStrings = (property, ordering) => {
  let sortOrder = 1;
  if(property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    /*
      * works with strings and numbers
    */
    const result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    if(ordering==='desc') {
      return result * sortOrder * -1;
    } else {
      return result * sortOrder;
    }
  };
};
export default compareValues;

